import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ReportsAbstractService } from './reports-abstract.service';
import { ResolveSummaryResponse } from '../reports/models/reports';

@Injectable()
export class ResolveReportService extends ReportsAbstractService {
  public reportRoute: string = 'resolve_report';
  public lastSummary: ResolveSummaryResponse = null;

  constructor(protected http: HttpClient) {
    super(http);
    this.route = this.reportRoute;
  }

  getSummary(params: object): Observable<ResolveSummaryResponse[]> {
    return this.http.post<ResolveSummaryResponse[]>(this.route + '/summary/', params);
  }
}
